module.exports = __webpack_public_path__ + "img/202307_04.b7512705.jpg";